import(/* webpackMode: "eager" */ "/home/runner/work/psx-frontend/psx-frontend/app/scanner/price-action/page.tsx");
